import { IPrivateChannel } from '../interfaces/channel';

export const getExistedPrivateChannel = (
  privateChannels: IPrivateChannel[],
  participantUserId: string,
): IPrivateChannel | undefined => {
  // TODO: UEF-5469 Investigate why some items in privateChannels are undefined
  const privateChannel = privateChannels.filter(x => x.channel).find(({ userIds }) =>
    userIds.includes(participantUserId),
  );

  return privateChannel;
};
